// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const getTableSettings = (payload = null) => http.post('apiUserDocument/getTableSettings', payload).then(getData);

export const get = (payload = null) => http.post('apiUserDocument/getRows', payload).then(getData);

export const getRow = (rowID) => http.get(`apiUserDocument/getRow&ID=${rowID}`).then(getData);

export const create = (row) => http.post('apiUserDocument/createDocument', row).then(getData);

export const update = (row) => http.put('apiUserDocument/editDocument&ID=' + row.ID, row).then(getData);

export const remove = (row) => http.post('apiUserDocument/deleteDocument', row).then(getData);